// How far along a project is, as a bar.
//
// The same component on the technician's ticket and the client's portal,
// fed the same number (`projectProgressPercent` in packages/shared), so
// "the client sees 60%" and "I see 60%" are never two different claims.

export function ProjectProgressBar({
  percent,
  done,
  total,
  label = 'Progress',
}: {
  percent: number;
  /** Tasks done and in total, for the caption. Omit to show the figure alone. */
  done?: number;
  total?: number;
  label?: string;
}): React.ReactElement {
  const value = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div>
      <div className="flex items-baseline justify-between gap-3">
        <span className="text-sm font-semibold text-[var(--color-header)]">{label}</span>
        <span className="text-sm text-[var(--color-muted)]">
          <span className="text-lg font-bold tabular-nums text-[var(--color-header)]">{value}%</span>
          {typeof total === 'number' && total > 0 && (
            <span className="ml-2">
              {done ?? 0} of {total} task{total === 1 ? '' : 's'} done
            </span>
          )}
        </span>
      </div>
      <div
        className="mt-2 h-3 w-full overflow-hidden rounded-full bg-[var(--color-border)]"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
      >
        <div
          className={`h-full rounded-full transition-all duration-500 ${
            value === 100 ? 'bg-emerald-500' : 'bg-[var(--color-t3-blue)]'
          }`}
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  );
}
